import { client } from "./api";
import { IPayment } from "interfaces/Payment";
import { IFilterData, IGetFilterProps } from "interfaces/FilterProps";

export async function getPaymentsService({
  order,
  relations,
  skip,
  take,
  where,
}: IGetFilterProps<IPayment>): Promise<IFilterData<IPayment>> {
  const api = client();
  const response = await api.get<IFilterData<IPayment>>("payments", {
    params: {
      take,
      skip,
      relations: JSON.stringify(relations),
      order: JSON.stringify(order),
      where: JSON.stringify(where),
    },
  });
  return response.data;
}

export async function searchPaymentsService(
  query: string
): Promise<IFilterData<IPayment>> {
  const api = client();
  const response = await api.get<IFilterData<IPayment>>(
    `payments?filter=${query}`
  );
  return response.data;
}

export async function payPolicemanService(id: string) {
  const api = client();
  const response = await api.post("payments", {
    policemanId: id,
  });
  return response.data;
}
